import DepositPurchase from './deposit-purchase.vue'
export default DepositPurchase
